import React from 'react';
import { Link } from 'react-router-dom';
import { Background, Container, Content } from './styled';
import logo from '../../assets/logo.png';

const NotFound = () => {
  return (
    <Container>
      <Content>
        <img src={logo} alt="Fundação MT" />
        <h1>404</h1>
        <h3>Página não encontrada.</h3>
        <a href={process.env.REACT_APP_URL_WEB}>Ir para homepage</a>
      </Content>
      <Background>
        <p>© 2020 ESMenezes - Todos os direitos estão reservados.</p>
      </Background>
    </Container>
  );
};

export default NotFound;
